# Filter an array to just non-empties
export nonEmpty = (array) -> (array || []).filter (val) -> !!val
